import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export function initTopsellerSlider() {
  const topseller = document.getElementById('js-topseller');
  if (!topseller) {
    return;
  }
  new Swiper(topseller, {
    modules: [Navigation],
    slidesPerView: 'auto',
    spaceBetween: 12,
    grabCursor: true,
    loop: true,
    navigation: {
      nextEl: topseller.querySelector('.swiper-button-next'),
      prevEl: topseller.querySelector('.swiper-button-prev'),
      addIcons: false,
    },
  });
}
